module.exports = __webpack_public_path__ + "img/50ne.11313dd2.svg";